export default __webpack_public_path__ + "static/media/2067.5e79e710.png";